module.exports = __webpack_public_path__ + "static/media/close-rounded@3x.3bb865c4.png";